import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import DefaultLayout from '@/layouts/DefaultLayout.vue'
import {useRoute} from 'vue-router'
import { onMounted, ref } from 'vue'
import ProfileService from '@/services/ProfileService'
import router from '@/router'


export default /*#__PURE__*/_defineComponent({
  __name: 'ChannelRedirectView',
  setup(__props) {

const route = useRoute()
const id = route.params.id
const service = new ProfileService()
const user = ref()
const nickname = ref('')

onMounted(async () => {
    user.value = await service.UserInfo(id)
    if(user.value.nickname) {
        nickname.value = user.value.nickname
    } else {
        nickname.value = user.value.name.substring(0,3) + user.value.id
    }
    router.push({name: 'social-profile-nickname', params: { nickname: nickname.value}})
})



return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createBlock(DefaultLayout, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_icon, {
        name: "ri-loader-2-fill",
        animation: "spin",
        class: "icon"
      })
    ]),
    _: 1
  }))
}
}

})